import {
  WAREHOUSE_LIST_URL,
  WAREHOUSE_SET_WRITE_ENABLED_URL,
} from "../../api/api";
import {
  GET_WAREHOUSES,
  GET_WAREHOUSES_FAIL,
  GET_WAREHOUSES_SUCCESS,
} from "./actionTypes";
import { createAPIAction } from "../store/apiMiddleware/utils";

export const getWarehouseConnections = () =>
  createAPIAction({
    url: WAREHOUSE_LIST_URL,
    actionTypes: [GET_WAREHOUSES, GET_WAREHOUSES_SUCCESS, GET_WAREHOUSES_FAIL],
    method: "get",
  });

export const setWarehouseWriteEnabled = (id, write_enabled) =>
  createAPIAction({
    url: WAREHOUSE_SET_WRITE_ENABLED_URL.replace(":warehouse_id", id),
    method: "post",
    body: { write_enabled },
  });
